import { useState } from "react";
import { Col } from "reactstrap";
import { CallNotificationData } from "../../../../Data/Messenger/Messenger";
import SearchNotFoundClass from "../../../CommonComponents/SearchNotFound/SearchNotFoundClass";

const CallNotification = () => {
  const [notification, setNotification] = useState(CallNotificationData);
  return (
    <Col sm="7" className="col-sm-7 position-relative">
      <div className="call-log-main custom-scroll">
        {notification.length > 0 ? (
          notification.map((item, index) => (
            <div className="coll-log-group" key={index}>
              <div className="log-content-left">
                <div className="d-flex">
                  <i data-feather="phone-incoming" />
                  <div className="flex-grow-1">
                    <h5>{item.title}</h5>
                  </div>
                </div>
              </div>
              <div className="log-content-right">
                <h6>{item.time}</h6>
              </div>
            </div>
          ))
        ) : (
          <div className="coll-log-group">
            <SearchNotFoundClass word="No Call history" />
          </div>
        )}
      </div>
      <div className="call-log-clear" onClick={() => setNotification([])}>
        <i className="fa fa-trash font-danger" />
        <span className="font-danger">Delete call log</span>
      </div>
    </Col>
  );
};

export default CallNotification;
